<template>
  <div>
    <mt-header title class="dl_header_white">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="container">
      <h3 class="dl_font1_color dl_margin1_top">{{$t('设置登录密码')}}</h3>

      <mt-field label :placeholder="$t('设置密码')" class="dl_margin4_top" v-model="password"></mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('再次输入')" class="dl_margin4_top" v-model="repassword"></mt-field>
      <div class="dl_line"></div>

      <mt-button type="primary" class="dl_margin4_top" size="large" @click="doLogin">{{$t('确认')}}</mt-button>
    </div>
  </div>
</template>

<script>
import { validateEmpty } from "@/utils/validate";
import { setToken } from "@/utils/auth";
import { Toast } from "mint-ui";
import { httpDoLogin } from "@/api/login";
export default {
  name: "Password",
  data() {
    return {
      password: "",
      repassword: ""
    };
  },
  methods: {
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    doLogin: function() {
      if (validateEmpty(this.repassword) || validateEmpty(this.password)) {
        Toast(this.$t("empty"));
        return;
      }
      if (this.password != this.repassword) {
        Toast(this.$t("noequal"));
        return;
      }
      var p = {};
      httpDoLogin(p)
        .then(res => {
          Toast(res.message);
        })
        .catch(() => {});
      this.$router.replace("/index/home");
    }
  },
  components: { Toast }
};
</script>

<style scoped>
.container {
  padding: 10px;
}
.forget_pass {
  font-size: 16px;
  margin: 25px 0px;
}
a{
  color: #879BAA;
}
.btn{
  color: #1e86db;
}

.mint-button--primary{
  background-color:#1E87D9;
}
</style>

